import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const alertsBar = document.querySelector('#alerts-bar');

  if (alertsBar) {
    const closeBtn = alertsBar.querySelector('.alerts-bar__close');

    closeBtn.addEventListener('click', function () {
      alertsBar.classList.remove('visible');
      document.body.classList.remove('has-alerts-bar');
    });

    const carousel = document.querySelector('.alerts-bar__carousel');
    const slides = carousel.querySelectorAll('.alert-item');
    const args = {
      slidesPerView: 1,
      navigation: {
        prevEl: alertsBar.querySelector('.swiper-button-prev'),
        nextEl: alertsBar.querySelector('.swiper-button-next'),
      },
    };

    if (1 === slides.length) {
      args.watchOverflow = true;
      args.loop = false;
    } else {
      args.loop = true;
    }
    new Swiper(carousel, args);
  }
});
